import { START_DATE_LAST_MONTH, TODAY_PLUS_7_DATE } from '../../../common/constants'
import { useUserContext } from '../../../auth/UserProvider'
import { useUserCentersStatistics } from '../../../services/user'

import StatisticsCardUI from './View'

const StatisticsCard = () => {
  const { centres, statusList } = useUserContext()
  const period = {
    startDate: START_DATE_LAST_MONTH,
    endDate: TODAY_PLUS_7_DATE,
  }

  const joinCenters = () => {
    return Array.isArray(centres)
          ? centres.map(centre => centre.hideId).join(',')
          : centres
  }
  
  const { data, isLoading: isLoadingShippingsStatics } = useUserCentersStatistics(
    joinCenters(),
    period,
    statusList,
  )

  return (
    <StatisticsCardUI
      period={period}
      chartData={data}
      isLoadingShippingsStatics={isLoadingShippingsStatics}
    />
  )
}

export default StatisticsCard
